import IconsGenerator from './icons/IconsGenerator.vue'

export default {
  IconsGenerator
}
